import {autorun, makeAutoObservable} from "mobx";
import {resources} from "../resources";
import {AwaitLock} from "../utils/AwaitLock";
import {fancyAlert} from "./alert";
import {connection, InsufficientStorageError} from "./connection";
import {cubeModel} from "./cube";
import {occupancyModel} from "./occupancy";
import {trace} from "./trace";

function findCubesToOccupy() {
	const occupiedCubeIds = new Set(occupancyModel.occupancies.map(occupancy => occupancy.box.cube.hostname));
	return cubeModel.cubes.filter(cube => !occupiedCubeIds.has(cube.hostname));
}

export function installAutoOccupy() {
	// if we go online, we automatically occupy a box in cubes where we don't have any occupancy.
	// this implements the desired behaviour when the user signs up on the cube and opens the link.
	// also, this kicks in when the user verifies a cube (through device location or location code).

	// use a lock to make sure, there is only one auto occupy processing at a time
	const lock = new AwaitLock();

	autorun(async () => {
		// it's important to call findCubesToOccupy here, otherwise mobx won't track this function,
		// since the second call to findCubesToOccupy() runs asynchronously.
		if (connection.online && findCubesToOccupy()) {
			try {
				await lock.acquire();
				for (let cube of findCubesToOccupy()) {
					trace.add("Auto occupy", {hostname: cube.hostname});
					console.info("Automatically occupying box at cube", cube);
					try {
						autoOccupy.pending = true;
						await occupancyModel.occupy(cube.hostname);
						// untrack cube to avoid further automatic occupancies
						await cubeModel.remove(cube.hostname);
					}
					catch (error) {
						const isInsufficientStorage = error instanceof InsufficientStorageError;
						fancyAlert(
							isInsufficientStorage
								? resources.strings.InsufficientStorageMessage
								: resources.strings.OccupyErrorMessage,
						);
					}
				}
			}
			finally {
				lock.release();
			}
		}
	});
}

class AutoOccupy {
	pending = false;

	constructor() {
		makeAutoObservable(this);
	}
}

export const autoOccupy = new AutoOccupy();
